import BaseModel from '../BaseModel';

export default class Settings extends BaseModel {
  static entity = 'userSettings';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      userId: this.attr(null),
      locale: this.string(null),
      integrationVacancyDialog: this.boolean(null),
      integrationKanbanDialog: this.boolean(null),
      integrationKanbanDialogAuto: this.boolean(null),
    };
  }

  static apiConfig = {
    actions: {
      update(payload) {
        return this.put('users/settings', payload);
      },
    },
  }
}
